import styled from "styled-components";

export const ActionsContainer = styled.span`
    z-index: 1000;
    position: absolute;
    top: 0;
    right: 0;
    border: 1px solid lightgrey;
    background: whitesmoke;
    border-radius: 10px;
    padding: var(--spacer-XS);
    margin-left: var(--spacer-XS);
    white-space: nowrap;
`;

export const AiSuggestionChip = styled.div`
    margin-top: var(--spacer-XXS);
    padding: var(--spacer-XXS) var(--spacer-XS);
    background-color: var(--bg-hover-light);
    border: var(--border-thin) solid var(--info-color);
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    gap: var(--spacer-XS);
    font-size: 0.85em;
`;

export const AiSuggestionText = styled.span`
    flex: 1;
    color: var(--text-body);
    white-space: pre-wrap;
    word-break: break-word;
`;

export const AiSuggestionLabel = styled.span`
    color: var(--info-color);
    font-weight: 600;
    flex-shrink: 0;
`;